import React from 'react';
import { Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
//custom-hook
import useAssignedLibrary from 'utils/customHooks/useAssignedLibrary';
// Imagen 
import preview from 'assets/img/preview.jpg';
// icons
import { FaTrophy } from 'react-icons/fa';
//preview books without covers
import CoverImg from '../coverImage/CoverImage';
import Authors from '../authors';
// Componentes
import Button from 'components/userzone/buttons/ButtonCustom';

const ItemListAwardedBook = ({ award }) => {
  const { t } = useTranslation(['home']);
  const { assignedLibrary } = useAssignedLibrary();
  const navigate = useNavigate();

  const goToDetail = (productId) => {
    navigate(`/${assignedLibrary}/libro/${productId}`);
  };

  return (
    <>
      {award.products.map((product) => (
        <div key={product.id} className="store-item award-container">
          <div className="store-item award-container">
          <h4 className="text-center name-award">{award.nombre}</h4>
            <div className="store-cover">
            <div className="trophyDivNew">
              <FaTrophy />
            </div>
              <div className={`img-container ${product.isReview ? 'img-review' : ''} ${product.isReview ? 'default-cursor' : 'pointer-cursor'}`}>
                <div className="overlay"></div>
                <Link to={`/${assignedLibrary}/libro/${product.id}`}>
                  <CoverImg
                    src={product.cover || preview}
                    className="default-cursor"
                  />
                </Link>
              </div>
            </div>
            <Row className="img-caption img-caption-no-margin">
              <Col xs={12}>
              <Link className='link-awards' to={`/${assignedLibrary}/libro/${product.id}`}>
                  <h5 className="title-awards limit-long" title={product.title}>
                    {product.title.charAt(0).toUpperCase() + product.title.slice(1).toLowerCase()}
                  </h5>
                </Link>
              </Col>
              <Col xs={12} className="d-flex justify-content-center">
                {product.authors.length > 0 && <Authors elements={product.authors} />}
              </Col>
            </Row>
            <div className="text-center">
              <Button
                variant="outline-dark"
                size="sm"
                className="btn-awards"
                onClick={() => goToDetail(product.id)}
              >
                {t('seeFile')}
              </Button>
            </div>
          </div>
        </div>
      ))}
    </>
  );
};

export default ItemListAwardedBook;